module.exports = __webpack_public_path__ + "img/informed.2fa4e364.jpg";